/** localStorage key marking that this browser has seen the game before. */
export const VISITED_KEY = 'words-happen:visited';

/** The long-lived first-visit marker. Injectable so it can be tested. */
export interface VisitMarker {
  /** Whether the visitor has been here before. False when storage is unavailable: they are treated as new. */
  returning: () => boolean;
  mark: () => void;
}

export const storageVisitMarker = (storage: () => Storage = () => window.localStorage): VisitMarker => ({
  returning: () => {
    try {
      return storage().getItem(VISITED_KEY) !== null;
    } catch {
      return false;
    }
  },
  mark: () => {
    try {
      storage().setItem(VISITED_KEY, new Date().toISOString());
    } catch {
      // Storage unavailable (private mode, blocked): the visitor stays new.
    }
  },
});
